// extracted by mini-css-extract-plugin
export var button = "MetaLandingPage-module__button___pVi7K";
export var cancel = "MetaLandingPage-module__cancel___gU14d";
export var content = "MetaLandingPage-module__content___LAUnN";
export var copy = "MetaLandingPage-module__copy___YyIHT";
export var disclaimer = "MetaLandingPage-module__disclaimer___yCn7x";
export var head = "MetaLandingPage-module__head___z_lEK";
export var headline = "MetaLandingPage-module__headline___VyXnJ";
export var hero = "MetaLandingPage-module__hero___IzSKB";
export var lottie = "MetaLandingPage-module__lottie___vhPe3";
export var picture = "MetaLandingPage-module__picture___lrxG7";
export var s = "MetaLandingPage-module__s___YkSWs";
export var subhead = "MetaLandingPage-module__subhead___dHQaj";
export var title = "MetaLandingPage-module__title___imjPK";
export var wrapper = "MetaLandingPage-module__wrapper___h1j2t";